export default __webpack_public_path__ + "static/media/warning.50679509.svg";